module.exports = __webpack_public_path__ + "static/prime-95b9e9be4a169b9d5502e38dc629017f.pdf";